import { Button, TextField } from "@material-ui/core";
import { KeyValuePair } from "@shoothill/core";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";

import { BaseModal } from "Components/Modal/BaseModal";
import { SnackBar } from "Components/SnackBar/SnackBar";
import { CancelButton } from "Globals/Styles/Control/Buttons";
import { AddPlanOfWorkModalStyle } from "Views/Project/Modals/Modal.Styles";
import { FormModalSection, FormRow } from "Views/Stock/Shared/Shared.styles";
import { IssueViewModel } from ".";
import { MultiSelectView } from "Components/Select/MultiSelect";

interface IProps {
    viewModel: IssueViewModel;
}

export const IssueView: React.FC<IProps> = observer((props) => {
    const viewModel = props.viewModel;

    const [selectedToProjectDirectoryPersonUserNames, setSelectedToProjectDirectoryPersonUserNames] = useState<string>("None"); // Display only
    const [selectedCCProjectDirectoryPersonUserNames, setSelectedCCProjectDirectoryPersonUserNames] = useState<string>("None"); // Display only

    const handleSetSelectedToProjectDirectoryPersonUsers = (val: any) => {
        viewModel.setSelectedToProjectDirectoryPersonUsers(val);
        const options: KeyValuePair[] = viewModel.getProjectDirectoryPersonUserOptions;

        const selectedNames: string[] = options.filter((o) => val.includes(o.value)).map((o) => o.key);

        if (selectedNames.length > 0) {
            setSelectedToProjectDirectoryPersonUserNames(selectedNames.join(", "));
        } else {
            setSelectedToProjectDirectoryPersonUserNames("None");
        }
    };

    const handleSetSelectedCCProjectDirectoryPersonUsers = (val: any) => {
        viewModel.setSelectedCCProjectDirectoryPersonUsers(val);
        const options: KeyValuePair[] = viewModel.getProjectDirectoryPersonUserOptions;

        const selectedNames: string[] = options.filter((o) => val.includes(o.value)).map((o) => o.key);

        if (selectedNames.length > 0) {
            setSelectedCCProjectDirectoryPersonUserNames(selectedNames.join(", "));
        } else {
            setSelectedCCProjectDirectoryPersonUserNames("None");
        }
    };

    const getProjectDirectoryPersonUserOptions = (includeDeleted: boolean): KeyValuePair[] => {
        return viewModel.getProjectDirectoryPersonUserOptions === undefined ? [] : viewModel.getProjectDirectoryPersonUserOptions.slice();
    };

    return (
        <BaseModal
            open={viewModel !== null}
            onClose={viewModel.cancel}
            title={viewModel.title}
            PaperComponent={AddPlanOfWorkModalStyle}
            actions={
                <React.Fragment>
                    <Button autoFocus color="secondary" disabled={viewModel.server.IsBusy || viewModel.IsLoading} onClick={viewModel.apiIssueAsync} variant="contained">
                        Send
                    </Button>
                    <CancelButton disabled={viewModel.server.IsBusy || viewModel.IsLoading} onClick={viewModel.cancel}>
                        Cancel
                    </CancelButton>
                </React.Fragment>
            }
        >
            <FormModalSection>
                <FormRow grid dc={"1fr"}>
                    <p style={{ fontSize: "14px" }}>Selected To users: {selectedToProjectDirectoryPersonUserNames}</p>
                    <MultiSelectView
                        style={{ width: "100%", marginBottom: "20px" }}
                        display="To users"
                        fieldName="selectedToProjectDirectoryPersonUsers"
                        values={viewModel.model.selectedToProjectDirectoryPersonUsers}
                        getOptions={getProjectDirectoryPersonUserOptions}
                        handleChange={(values: number[] | null) => handleSetSelectedToProjectDirectoryPersonUsers(values)}
                    />
                </FormRow>
                <FormRow grid dc={"1fr"}>
                    <p style={{ fontSize: "14px" }}>Selected CC users: {selectedCCProjectDirectoryPersonUserNames}</p>
                    <MultiSelectView
                        style={{ width: "100%", marginBottom: "20px" }}
                        display="CC users"
                        fieldName="selectedCCProjectDirectoryPersonUsers"
                        values={viewModel.model.selectedCCProjectDirectoryPersonUsers}
                        getOptions={getProjectDirectoryPersonUserOptions}
                        handleChange={(values: number[] | null) => handleSetSelectedCCProjectDirectoryPersonUsers(values)}
                    />
                </FormRow>
            </FormModalSection>
            <SnackBar
                messageText={viewModel.snackMessage}
                messageType={viewModel.snackType}
                active={viewModel.snackbarState}
                closeOption={() => viewModel.setSnackbarState(false)}
                autoHideDuration={5000}
            />
        </BaseModal>
    );
});
